import { ColumnType, ReportColumn } from "@/types/evaluate";
import React from "react";
import { DatasetColumnCell } from "./DatasetColumnCell";
import { DefaultColumnCell } from "./DefaultColumnCell";

interface CellProps {
  column: ReportColumn;
}

export const Cell: React.FC<CellProps> = ({ column }) => {
  if (column.column_type === ColumnType.DATASET) {
    return <DatasetColumnCell column={column} />;
  } else {
    return <DefaultColumnCell column={column} />;
  }
};
